// components/landing/FAQSection.js
import { useState } from 'react';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Quanto tempo leva para ter meu app publicado?",
      answer: "O processo de criação do app leva em média 2 dias úteis. A publicação nas lojas pode levar de 3 a 7 dias para a Google Play Store e de 5 a 10 dias para a Apple App Store, dependendo da aprovação."
    },
    {
      question: "Preciso ter uma conta de desenvolvedor?",
      answer: "Não é obrigatório. Nós podemos publicar o app em nossa conta de desenvolvedor (com sua marca) ou ajudamos você a criar sua conta e publicar em seu nome."
    },
    {
      question: "Meu site precisa de alguma adaptação?",
      answer: "Na maioria dos casos, não é necessário nenhuma adaptação. Se seu site já é responsivo (funciona bem em celulares), o app funcionará perfeitamente."
    },
    {
      question: "Posso atualizar o conteúdo do app depois?",
      answer: "Sim! Como o app basicamente exibe seu site, qualquer atualização que você fizer no site será automaticamente refletida no app, sem necessidade de novas publicações nas lojas."
    },
    {
      question: "Qual a diferença entre os planos?",
      answer: "Os planos variam principalmente pelo número de plataformas (Android/iOS), quantidade de ícones no menu, nível de suporte e período de atualizações incluídas. O plano Profissional é o mais completo para a maioria dos casos."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white relative">
      {/* Background Pattern - Subtle diagonal stripes */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          backgroundImage: `repeating-linear-gradient(45deg, #000 0, #000 1px, transparent 0, transparent 50%)`,
          backgroundSize: '10px 10px'
        }}
      ></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-lg font-light leading-relaxed">
            Encontre respostas para as perguntas mais comuns sobre nossa plataforma
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item mb-4 border border-gray-200 rounded-lg overflow-hidden ${activeIndex === index ? 'active' : ''}`}
            >
              <button
                className="w-full flex justify-between items-center p-6 bg-white text-left font-semibold text-gray-900 focus:outline-none cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <i className={`fas fa-chevron-${activeIndex === index ? 'up' : 'down'} text-gray-400 transition-transform duration-300`}></i>
              </button>
              <div className="faq-answer transition-all duration-300 overflow-hidden"
                style={{ maxHeight: activeIndex === index ? '500px' : '0' }}>
                <div className="p-6 bg-white border-t border-gray-100">
                  <p className="text-gray-500 font-light leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;